import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';

@Component({
  selector: 'app-sfa-icebox-detail',
  templateUrl: './sfa-icebox-detail.component.html',
  styleUrls: ['./sfa-icebox-detail.component.scss']
})
export class SfaIceboxDetailComponent extends GridBaseCase {

  constructor() { super(); }

  ngOnInit() {
  }
  EventLink(){

  }

}
